

export const emptyResponse = ()=>{
    return {
        status: "error",
        message: [],
    }
}

export const selectResponse = (response) => {
    if(response.length === 0){
        return [{value: '', label: 'No Data Found'}]
      }
      if(response.loading){
        return [{value: '', label: 'Loading...'}]
     }
   
     return response.map(state => ({
      value: state.id,
      label: state.name
    }))
}
 export const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export   const getAvatarColor = (color) => {
    switch (color) {
      case "blue": return "bg-blue-100 text-blue-600";
      case "purple": return "bg-purple-100 text-purple-600";
      case "red": return "bg-red-100 text-red-600";
      case "green": return "bg-green-100 text-green-600";
      case "yellow": return "bg-yellow-100 text-yellow-600";
      case "indigo": return "bg-indigo-100 text-indigo-600";
      case "pink": return "bg-pink-100 text-pink-600";
      case "cyan": return "bg-cyan-100 text-cyan-600";
      default: return "bg-gray-100 text-gray-600";
    }
  };

  export  const getCallStatusColor = (status) => {
    switch (status) {
      case "INCOMING": return "bg-green-100 text-green-800";
      case "MISSED": return "bg-red-100 text-red-800";
      case "OUTGOING": return "bg-yellow-100 text-yellow-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };
 